import { render, staticRenderFns } from "./DesignBaseCheckbox.vue?vue&type=template&id=490029b5&"
import script from "./DesignBaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./DesignBaseCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports